import { render, staticRenderFns } from "./CreateFormJson.vue?vue&type=template&id=5519f015&scoped=true"
import script from "./CreateFormJson.vue?vue&type=script&lang=js"
export * from "./CreateFormJson.vue?vue&type=script&lang=js"
import style0 from "./CreateFormJson.vue?vue&type=style&index=0&id=5519f015&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5519f015",
  null
  
)

export default component.exports